import { render, staticRenderFns } from "./SalePricePreview.vue?vue&type=template&id=0761d97a&scoped=true&"
import script from "./SalePricePreview.vue?vue&type=script&lang=js&"
export * from "./SalePricePreview.vue?vue&type=script&lang=js&"
import style0 from "./SalePricePreview.vue?vue&type=style&index=0&id=0761d97a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0761d97a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VRow})
